module.exports = __webpack_public_path__ + "img/logo6.df2b5d0a.png";